module.exports = __webpack_public_path__ + "static/media/scenarios-resized.6dcd9517.png";